/*
 * @Author       : 四川华西绿舍建材有限公司
 * @Date         : 2023-09-12 13:33:57
 * @LastEditTime : 2023-09-18 13:59:53
 * @LastEditors  : yangxr
 * @Description  : 皮重任务API
 * @FilePath     : \icps_change\src\api\GHnumber\sellMaterialTask.js
 */
import request from '@/utils/request'
export const queryPage = '/icps/system/sign/dataCollection/sellRawMaterials/queryPage'
export const saveOrUpdate = '/icps/system/sign/dataCollection/sellRawMaterials/saveSellRawMaterials'
/*删除售料任务*/
export function deleteSellRawMaterials(params) {
    return request({
        url: '/icps/system/sign/dataCollection/sellRawMaterials/deleteSellRawMaterials',
        method: 'GET',
        params
    })
}
/*修改售料任务*/
export function updatSellRawMaterials(data) {
    return request({
        url: '/icps/system/sign/dataCollection/sellRawMaterials/updatSellRawMaterials',
        method: 'post',
        data
    })
}
/*冲销*/
export function backSellRawMaterials(data) {
    return request({
        url: '/icps/system/sign/dataCollection/sellRawMaterials/backSellRawMaterials',
        method: 'post',
        data
    })
}
/*获取库存仓*/
export function queryWarehouseList(data) {
    return request({
        url: '/icps/system/sign/basics/inventory/queryWarehouseList',
        method: 'post',
        data
    })
}
/*获取原物料*/
export function queryRawNameList(params) {
    return request({
        url: '/icps/system/sign/basics/rawMaterials/queryRawNameList',
        method: 'get',
        params
    })
}